<div class="main-container">
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <p-toast></p-toast>
  <div class="first-row">
    <div class="left-container">
      <p-selectButton [options]="translationModes" [(ngModel)]="translationMode" (onChange)="changeMode()">
      </p-selectButton>
      <p>
        Input code here
      </p>
      <textarea [(ngModel)]="inputText" cols="80" rows="34" class="input-box"></textarea>
      <p-button label="Convert" (onClick)="stripTags()"></p-button>
    </div>
    <div class="right-container">
      <p>
        How to use
      </p>
      <br>
      <p>
        1. Create a new translated article by clicking
        the "+" under your flag in the programme list.
      </p>
      <p>
        2. Open the visual editor from the article settings
      </p>
      <p>
        3. Copy and paste the code in this tool
      </p>
      <p>
        4. Paste the output back into the WordPress code editor
      </p>
      <p>
        5. Switch back to the visual editor
      </p>
    </div>
  </div>
  <div class="second-row">
    <div class="line-item-container">
      <div>
        <p>
          French
        </p>
      </div>
      <div>
        <p>
          Dutch
        </p>
      </div>
      <div>
        <p>
          English
        </p>
      </div>
    </div>
      <div *ngFor="let item of translationItems; index as i" 
      [ngClass]="{'line-item-container-focus': selectedItem == item, 'line-item-container': true}" (click)="selectItem(item)" [formGroup]="translationItemFormGroup[i]">
            <div>
              <input formControlName="french">
              <div  *ngIf="selectedItem == item">
                <p-button (onClick)="orderBefore()" icon="pi pi-arrow-up" label="Up"></p-button>
                <p-button (onClick)="orderAfter()" icon="pi pi-arrow-down" label="Down"></p-button>
                <p-button (onClick)="update()" label="Save"></p-button>
                <p-button (onClick)="delete()" icon="pi pi-trash" label="Delete" styleClass="p-button-danger"></p-button>
              </div>
            </div>
        <div>
          <input formControlName="dutch">
        </div>
        <div>
          <input formControlName="english">
        </div>
      </div>
    <div *ngIf="translationItemForm" class="line-item-container" [formGroup]="translationItemForm">
      <div>
        <input formControlName="french">
      </div>
      <div>
        <input formControlName="dutch">
      </div>
      <div>
        <input formControlName="english">
      </div>
    </div>
    <div>
      <button (click)="postNewLine()">Post new line</button>
    </div>
  </div>
</div>